export const PARTICIPATION_REPORT_LOADING = 'PARTICIPATION_REPORT_LOADING';

export const PARTICIPATION_REPORT_GET_REPORT =
  'PARTICIPATION_REPORT_GET_REPORT';
export const PARTICIPATION_REPORT_CLEAR_REPORT =
  'PARTICIPATION_REPORT_CLEAR_REPORT';
export const PARTICIPATION_REPORT_ERROR = 'PARTICIPATION_REPORT_ERROR';



// WEBPACK FOOTER //
// ./src/pages/participation/state/report/types.js